import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ToastrService } from 'ngx-toastr';

import { GeneralToastComponent } from '../../toasts/general-toast/general-toast.component';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { SessionsService } from '../../services/sessions/sessions.service';
import { ParticipantFsDaily, ParticipantFsDolby } from '@sc/types';
import { NameService } from '../../services/name/name.service';

@Component({
  selector: 'sc-rename-participant-menu',
  templateUrl: './rename-participant-menu.component.html',
  styleUrls: ['./rename-participant-menu.component.scss'],
})
export class RenameParticipantMenuComponent implements OnInit {
  @Input() participant: ParticipantFsDaily;
  studioSession$ = this.sessionsService.studioSession$;
  name: string;

  constructor(
    private toastrService: ToastrService,
    private popoverController: PopoverController,
    private analyticsService: AnalyticsService,
    private sessionsService: SessionsService,
    private nameService: NameService
  ) {}

  ngOnInit() {
    this.name = this.participant.name;
  }

  async saveName() {
    try {
      if (!this.name) this.name = await this.nameService.getRandomName(4);
      await this.nameService.setName(this.studioSession$.value.sessionID, this.participant.userData.scUID, this.name);

      this.toastrService.success(null, `Successfully renamed ${this.name}`, {
        progressBar: true,
        progressAnimation: 'decreasing',
        closeButton: true,
        tapToDismiss: false,
        timeOut: 5 * 1000,
        toastComponent: GeneralToastComponent,
      });

      await this.popoverController.dismiss();
      await this.analyticsService.track('renamed participant', { success: true });
    } catch (error) { 
      this.toastrService.error(null, `Failed to rename`, {
        progressBar: true,
        progressAnimation: 'decreasing',
        closeButton: true,
        tapToDismiss: false,
        timeOut: 5 * 1000,
        toastComponent: GeneralToastComponent,
      });

      await this.popoverController.dismiss();
      await this.analyticsService.track('renamed participant', { success: false });
    }
  }
}
